<div class="flag">
  <span class="flag-label" [innerHTML]="label"></span>
</div>
